import React, { useCallback } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectContractActionsSummary,
  selectContractActionsQueryOptions
} from 'src/store/selectors/contractActionsSelectors';
import { loadContractActions } from 'src/store/actions/contractActionsActions';

const SEGMENTS = [
  { value: undefined, label: 'Todos', countKey: 'totalEvents' },
  { value: 'alta', label: 'Altas', countKey: 'altaCount' },
  { value: 'capital', label: 'Capital', countKey: 'capitalCount' },
  {
    value: 'terminacion',
    label: 'Terminaciones',
    countKey: 'terminationCount'
  },
  { value: 'cesion', label: 'Cesiones', countKey: 'cesionCount' }
];

const ContractActionsSegments = () => {
  const dispatch = useDispatch();
  const summary = useSelector(selectContractActionsSummary);
  const { bucket } = useSelector(selectContractActionsQueryOptions);
  const activeIndex = SEGMENTS.findIndex((segment) => segment.value === bucket);

  const handleChange = useCallback(
    (event, newIndex) => {
      dispatch(
        loadContractActions({ bucket: SEGMENTS[newIndex].value, page: 0 })
      );
    },
    [dispatch]
  );

  return (
    <Tabs
      indicatorColor="primary"
      textColor="primary"
      value={activeIndex}
      onChange={handleChange}
      variant="scrollable"
      scrollButtons="auto"
    >
      {SEGMENTS.map((segment) => (
        <Tab
          key={segment.label}
          label={`${segment.label} ${summary[segment.countKey]}`}
        />
      ))}
    </Tabs>
  );
};

export default ContractActionsSegments;
